import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { Divider } from '@fs/zion-ui'
import { marginVertical } from '../../../util/CssUtil'

const dark = css`
  background-color: #a9a9a9 !important;
`

export default function PSDivider({ verticalMargin = '20px', variant = 'standard' }) {
  const dividerProps = {}
  const dividerCss = [marginVertical(verticalMargin)]
  if (variant === 'light') {
    dividerProps.light = true
  } else if (variant === 'dark') {
    dividerCss.push(dark)
  }
  // dividerProps.css = dividerCss
  return (
    <div style={{ marginTop: '15px' }}>
      <Divider {...dividerProps} />
    </div>
  )
}

PSDivider.propTypes = {
  verticalMargin: PropTypes.string,
  variant: PropTypes.oneOf(['standard', 'light', 'dark']),
}
